<template>
  <DialogWrapper
    v-if="isPc"
    appendToBody
    class="job-alert-dialog is-pc"
    titleI18nKey="survey.label.jobAlertTip"
    saveBtnLabelI18nKey="survey.btn.continue"
    cancelBtnLabelI18nKey="survey.btn.back"
    :show.sync="isShow"
    :close-on-click-modal="false"
    @save="handelCreateSurvey"
    @cancel="handelCancelSurvey"
  >
    <div class="job-alert-content">
      <div>{{ $t('survey.label.jobAlertContent') }}</div>
      <ul>
        <li v-for="item in $t(`survey.label.${hasLogin ? 'jobAlertLoginList' : 'jobAlertNoLoginList'}`)" v-html="item" :key="item"></li>
      </ul>
      <br/>
      <div>{{ $t('survey.label.jobAlertContentFooter') }}</div>
    </div>
    <div v-if="showPolicy" class="checkbox-group">
      <el-form class="policy-form" ref="form" :model="formModel" :rules="formRules">
        <el-form-item class="policy-item" v-for="(policy, key) in bodyContent" :key="key" :prop="`policy_${policy.id}`">
          <span v-if="policy.type==='CONTENT'" v-html="policy.i18nContent" class="policy-type-content"></span>
          <el-checkbox v-if="policy.type==='CHECKBOX'" v-model="formModel[`policy_${policy.id}`]" class="checkbox" :key="policy.id">
            <span class="checkbox-content" v-html="policy.i18nContent"></span>
          </el-checkbox>
        </el-form-item>
      </el-form>
    </div>
  </DialogWrapper>
  <MobileDialog
    v-else
    class="job-alert-dialog is-mobile"
    saveBtnLabelI18nKey="survey.btn.continue"
    cancelBtnLabelI18nKey="survey.btn.back"
    :show.sync="isShow"
    :loading="loading"
    :logo="logo"
    @save="handelCreateSurvey"
    @cancel="handelCancelSurvey"
  >
    <template #title>
      <div class="title-content">{{ $t('survey.label.jobAlertTip') }}</div>
    </template>
    <template #content>
      <div class="job-alert-content">
        <div>{{ $t('survey.label.jobAlertContent') }}</div>
        <ul>
          <li v-for="(item, index) in $t(`survey.label.${hasLogin ? 'jobAlertLoginList' : 'jobAlertNoLoginList'}`)" v-html="item" :key="index"></li>
        </ul>
        <br/>
        <div>{{ $t('survey.label.jobAlertContentFooter') }}</div>
      </div>
      <div v-if="showPolicy" class="checkbox-group">
        <el-form class="policy-form" ref="form" :model="formModel" :rules="formRules">
          <el-form-item class="policy-item" v-for="(policy, key) in bodyContent" :key="key" :prop="`policy_${policy.id}`">
            <span v-if="policy.type==='CONTENT'" v-html="policy.i18nContent" class="policy-type-content"></span>
            <el-checkbox v-if="policy.type==='CHECKBOX'" v-model="formModel[`policy_${policy.id}`]" class="checkbox" :key="policy.id">
              <span class="checkbox-content" v-html="policy.i18nContent"></span>
            </el-checkbox>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </MobileDialog>
</template>

<script>
import _ from 'lodash'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import MobileDialog from '@/components/dialog/mobileCommonDialog.vue'
import { ACCOUNT_TYPE } from '@/constant/common'
import { addI18nProperty } from '@/i18n'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    DialogWrapper,
    MobileDialog
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    isPc: {
      type: Boolean,
      default: false
    },
    companyId: {
      required: true
    },
    logo: {
      type: String,
      default: ''
    },
    isAgreed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      showPolicy: false,
      policyInfo: {},
      formModel: {
      },
      surveyInfo: {}
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    },
    bodyContent () {
      if (this.policyInfo.popup) {
        _.forEach(this.policyInfo.popup.body, (policy) => {
          addI18nProperty(policy, 'i18nContent', 'content_cn', 'content_en')
        })
        return this.policyInfo.popup.body
      }
      _.forEach(this.policyInfo.link, (link) => {
        addI18nProperty(link, 'i18nContent', 'content_cn', 'content_en')
      })
      return this.policyInfo.link
    },
    formRules () {
      const rules = {}
      const checkboxRequired = [
        {
          validator: this.validateCheckBox,
          trigger: 'change'
        }
      ]
      _.forEach(this.bodyContent, (policy) => {
        if (policy.is_required) {
          rules['policy_' + policy.id] = checkboxRequired
        }
      })
      return rules
    },
    hasLogin () {
      const account = this.getCurrentAccount()
      return Boolean(account?.id)
    }
  },
  created () {
    this.loadCompanyPolicyInfo()
  },
  methods: {
    ...mapGetters('account', ['getCurrentAccount']),
    ...mapActions('survey', ['setFromPath']),
    ...mapActions('company', ['getCompanyPolicyInfo']),
    ...mapActions('personal', ['updateAgreement']),
    resetAgreementStatus () {
      _.forEach(this.formModel, (value, key) => {
        this.$set(this.formModel, key, this.isAgreed)
      })
      if (this.showPolicy) {
        this.$refs.form?.clearValidate()
      }
    },
    async loadCompanyPolicyInfo () {
      const resp = await this.getCompanyPolicyInfo({ companyId: this.companyId })
      if (resp) {
        this.policyInfo = resp
        this.showPolicy = true
        _.forEach(this.bodyContent, (policy) => {
          this.$set(this.formModel, `policy_${policy.id}`, false)
        })
      }
    },
    handelCancelSurvey () {
      this.isShow = false
    },
    async handelCreateSurvey () {
      const policyItemIds = []
      if (this.showPolicy) {
        let validCompanyPolicy = false
        this.$refs.form?.validate((valid) => {
          validCompanyPolicy = valid
        })
        if (!validCompanyPolicy) {
          this.$nextTick(() => {
            document.querySelector('.el-form-item.is-error').scrollIntoView({ block: 'center', behavior: 'smooth' })
          })
          return
        }
        _.forEach(this.formModel, (value, policy) => {
          if (policy.startsWith('policy_')) {
            policyItemIds.push(policy.substring(7))
          }
        })
      }
      this.setFromPath(this.$route.fullPath)
      const backUrl = `/recruiting/company/${this.companyId}/survey`
      if (this.hasLogin) {
        await this.handleUpdateAgreement(policyItemIds, backUrl)
      } else {
        this.$router.replace({ path: `/passport/${ACCOUNT_TYPE.CANDIDATE}/register`, query: { back: backUrl, company_id: this.companyId, agreed_policy_items: policyItemIds } })
      }
    },
    validateCheckBox (rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('common.message.continueWithAgreePolicy')))
      } else {
        callback()
      }
    },
    async handleUpdateAgreement (policyItemIds, url) {
      if (_.isEmpty(policyItemIds)) {
        this.$router.push({ path: url, query: { company_id: this.companyId } })
        return
      }
      this.loading = true
      const data = {
        is_agree: true,
        agree_item_ids: policyItemIds,
        company_id: this.companyId
      }
      try {
        const resp = await this.updateAgreement(data)
        if (resp) {
          this.$router.push({ path: url, query: { company_id: this.companyId } })
        }
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    isShow () {
      this.resetAgreementStatus()
    }
  }
}
</script>

<style lang="scss" scoped>
.job-alert-dialog {
  .job-alert-content {
    line-height: 22px;
    color: #000;
    word-break: break-word;
    white-space: break-spaces;

    ul {
      list-style: initial;
      margin-left: 16px;
    }
  }

  .policy-item {
    .checkbox {
      &.is-checked {
        ::v-deep {
          .el-checkbox__input {
            &.is-checked {
              .el-checkbox__inner {
                background-color: var(--custom-color, #0096cc);
                border-color: var(--custom-color, #0096cc);
              }
            }
          }
        }
      }
    }
  }
}
.is-pc {
  .checkbox-group {
    .policy-form {
      .policy-item {
        .policy-type-content {
          display: block;
          margin-top: 10px;
          margin-bottom: 10px;
        }

        &:last-child {
          margin-bottom: 10px;
        }
      }
    }

    ::v-deep {
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }

      .is-horizontal {
        display: none;
      }
    }

    ::v-deep {
      p {
        margin: 0;
      }

      a {
        color: var(--custom-color, #0096cc);
      }
    }
  }

  ::v-deep {
    .el-form-item {
      margin-bottom: auto;
    }
  }

  ::v-deep {
    .el-form-item__content {
      display: flex;
      flex-direction: column;
      line-height: unset;

      .el-form-item__error {
        left: 22px;
        position:relative;
        color: #F56C6C;
      }
    }
  }

  .checkbox {
    display: block;
    margin-top: 20px;

    ::v-deep {
      .el-checkbox__label {
        white-space: pre-wrap;
        vertical-align: top;
        width: 90%;
        word-break: break-word;
      }

      .el-checkbox__input {
        vertical-align: top;
        margin-top: 1px;
      }
    }

    .checkbox-content {
      color: black;

      &.error-message {
        display: none;
        color: red;
      }
    }
  }

  ::v-deep {
    .el-dialog {
      width: 40%;
      .el-dialog__footer {
        .dialog-footer {
          .save-btn {
            background: var(--custom-color, #0096cc);
            border-color: var(--custom-color, #0096cc);
          }

          .cancel-btn {
            &:hover {
              border-color: #c0c4cc;
            }
          }
        }
      }
    }
  }
}
.is-mobile {
  position: absolute;
  z-index: 9999999999 !important;
  .job-alert-content {
    font-size: 14px;
    word-break: break-word;

    ul {
      list-style: initial;
      margin-left: 18px;
    }
  }

  .checkbox-group {
    .policy-form {
      .policy-item {
        .policy-type-content {
          display: block;
          margin-top: 10px;
          margin-bottom: 10px;
        }

        &:last-child {
          margin-bottom: 5px;
        }
      }
    }

    ::v-deep {
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }

      .is-horizontal {
        display: none;
      }
    }

    ::v-deep {
      p {
        margin: 0;
      }

      a {
        color:  var(--custom-color, #0096cc);
      }
    }
  }

  ::v-deep {
    .el-form-item {
      margin-bottom: auto;
    }
  }

  ::v-deep {
    .el-form-item__content {
      display: flex;
      flex-direction: column;
      line-height: unset;

      .el-form-item__error {
        left: 22px;
        position:relative;
        color: #F56C6C;
      }
    }
  }

  .checkbox {
    display: block;
    margin-top: 20px;
    ::v-deep {
      .el-checkbox__label {
        white-space: pre-wrap;
        vertical-align: top;
        width: 90%;
        word-break: break-word;
      }

      .el-checkbox__input {
        vertical-align: top;
        margin-top: 2px;
      }
    }

    .checkbox-content {
      color: black;

      &.error-message {
        display: none;
        color: red;
      }
    }
  }
  ::v-deep {
    .dialog-content {
      border-top-color: var(--custom-color, #0096cc);
      .body-content {
        min-height: 10vh;
        min-height: 10dvh;
      }
      .container-footer {
        .dialog-footer {
          .save-btn {
            background: #fff;
            color: var(--custom-color, #0096cc);
            border: 1px solid var(--custom-color, #0096cc);

            &:hover {
              background: #fff;
              border-color: var(--custom-color, #0096cc);
            }
          }
        }
      }
    }
  }
}
</style>
